<!--
 * @LastEditors: Please set LastEditors
 * @desc: 常用操作（推荐函数）
 * @场景: 重构公式 抽屉中
-->
<template>
  <div>
    <div class="reconstruction_card">
      <el-card>
        <div v-if="!this.recommendData.description && this.reFunctions.length < 1" class="align_center p_20_0">
          暂无推荐函数，使用数据并检测成功后为您推荐适合函数～
        </div>
        <div v-else class="intelligent">
          <div class="space_between p_b_10">
            <span class="font_s_14 bold">数据特性：{{this.recommendData.description}}</span>
            <div>
              <el-select :trigger-on-focus="false" @change="selectEditionChange" style="width: 100px;" v-model="selectEdition" placeholder="请选择">
                <el-option
                  class="flex_c"
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div v-if="this.reFunctions.length > 0">
            <div v-if="selectEdition === 'detail'" class="rowFlex">
              <div v-if="this.reFunctions[this.recommendIndex]">
                <el-dropdown v-if="this.reFunctions[this.recommendIndex] && this.reFunctions[this.recommendIndex].common_params.length > 0" split-button type="danger" @click="handleClick" @command="addFunction">
                  <div>{{this.reFunctions[this.recommendIndex].title_chinese}}
                    <span v-if="this.reFunctions[this.recommendIndex].dropdownKey !== '无' && this.reFunctions[this.recommendIndex].dropdownKey !== ''"><br/>{{this.reFunctions[this.recommendIndex].dropdownKey}}</span>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item disabled class="align_center">
                      <span style="color: #555;">{{this.reFunctions[this.recommendIndex].first_param_name}}</span>
                    </el-dropdown-item>
                    <el-dropdown-item v-for="(y, item) in this.reFunctions[this.recommendIndex].common_params" :key="item" :command="y" class="flex">
                      <span v-if="y === '无'">无参数</span>
                      <span v-else>{{y}}</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-button v-else type="danger" style="height: 60px;width: 153px;" @click="handleClick(x)">{{this.reFunctions[this.recommendIndex].title_chinese}}</el-button>
              </div>
              <div class="flex_1 p_l_20">
                <div style="height: 140px;" class="font_s_14">
                  <el-scrollbar style="height: 100%;">
                    <div>
                      <el-tag type="info" size="small" effect="dark">{{this.reFunctions[this.recommendIndex].effect}}</el-tag>
                      <span class="">{{this.reFunctions[this.recommendIndex].short_instruction}}</span>
                    </div>
                    <div>说明：{{this.reFunctions[this.recommendIndex].instruction}}</div>
                    <div>格式：{{this.reFunctions[this.recommendIndex].format}}</div>
                    <div>例子：{{this.reFunctions[this.recommendIndex].example}}</div>
                    <div>输入：{{this.reFunctions[this.recommendIndex].input}}</div>
                    <div>输出：{{this.reFunctions[this.recommendIndex].output}}</div>
                  </el-scrollbar>
                </div>
                <div style="color: #A30014;" class="space_between p_5_0">
                  <div>
                    <span class="cursor bold" @click="updataRecommendIndex('left')" v-show="this.recommendIndex !== 0"><i class="el-icon-arrow-left"></i>上一个推荐</span>
                  </div>
                  <div>
                    <span class="cursor bold" @click="updataRecommendIndex('right')" v-show="this.recommendIndex !== (this.reFunctions.length - 1)">下一个推荐<i class="el-icon-arrow-right"></i></span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="selectEdition === 'list'" style="height: 171px;" class="list">
              <el-scrollbar style="height: 100%;">
                <div v-for="(x, index) in this.reFunctions" :key="index" class="flex font_s_14" style="background-color: #F7F7F7;padding: 3px 3px 0 3px;margin-bottom: 3px;">
                  <div class="flex flex_1">
                    <div style="width: 35px;">使用</div>
                    <div class="flex flex_1">
                      <div style="width: 110px;padding-top: 3px;" @click="getreFunction(x)">
                        <el-dropdown v-if="x.common_params.length > 0" split-button type="text" @click="handleClick(x)"  @command="addFunction">
                            {{x.title_chinese}} <span v-if="x.dropdownKey !== '无' && x.dropdownKey !== ''">{{x.dropdownKey}}</span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item disabled class="align_center">
                              <span style="color: #555;">{{x.first_param_name}}</span>
                            </el-dropdown-item>
                            <el-dropdown-item v-for="(y, item) in x.common_params" :key="item" :command="y" class="flex">
                              <span v-if="y === '无'">无参数</span>
                              <span v-else>{{y}}</span>
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                        <el-button v-else style="padding-bottom: 3px;" type="text" @click="handleClick(x)">{{x.title_chinese}}</el-button>
                      </div>
                      <div class="flex flex_1">{{x.short_instruction}}</div>
                    </div>
                  </div>
                  <div style="width: 35px;color: rgb(64, 158, 255);">
                    <el-tooltip class="item" placement="top-end" effect="light">
                      <div style="max-width: 300px" slot="content">
                        <div>推荐函数理由：{{x.instruction}}</div>
                        <div>格式：{{x.format}}</div>
                        <div>例子：{{x.example}}</div>
                        <div>输入：{{x.input}}</div>
                        <div>输出：{{x.output}}</div>
                      </div>
                      <span>详情</span>
                    </el-tooltip>
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </div>
          <div v-else class="align_center p_20_0">
            暂无推荐函数
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { getRequest } from '@/api/dailyBackTest.js'
export default {
  components: {
  },
  props: ['expression_id', 'dropdownKeyList', 'is_matrix', 'rightBlockType'],
  data () {
    return {
      reFunctions: [],
      recommendData: {},
      recommendIndex: 0,
      selectEdition: 'detail',
      reFunctionItem: {},
      options: [
        {value: 'detail', label: '详细'},
        {value: 'list', label: '列表'}
      ]
    }
  },
  created () {
  },
  mounted () {
    let selectEdition = localStorage.getItem('selectEdition')
    if (selectEdition) {
      this.selectEdition = selectEdition
    }
  },
  methods: {
    handleClick (x) {
      let data = {}
      if (this.selectEdition === 'list') {
        data = x
      } else {
        data = this.reFunctions[this.recommendIndex]
      }
      this.$emit('handleClick', data)
    },
    addFunction (command) {
      let data = {}
      if (this.selectEdition === 'detail') {
        if (command === '无') {
          this.reFunctions[this.recommendIndex].dropdownKey = ''
        } else {
          this.reFunctions[this.recommendIndex].dropdownKey = command
        }
        data = this.reFunctions[this.recommendIndex]
      } else {
        data = this.reFunctionItem
      }
      this.$emit('addFunction', command, data)
    },
    getreFunction (x) {
      this.reFunctionItem = x
    },
    selectEditionChange () {
      localStorage.setItem('selectEdition', this.selectEdition)
    },
    updataRecommendIndex (key) {
      if (key === 'left') {
        this.recommendIndex = this.recommendIndex - 1
      } else if (key === 'right') {
        this.recommendIndex = this.recommendIndex + 1
      }
    },
    getFingerPrintbyId () {
      var _this = this
      getRequest('/refactor/getFingerPrintbyId', {type: 'expression_id', value: this.expression_id}).then(function (x) {
        if (!x.data.message) {
          _this.fingerPrint = x.data.data
          _this.dataRecommendInfo()
        }
      })
    },
    dataRecommendInfo () {
      var _this = this
      var param = {
        dimension: this.fingerPrint.dimension,
        frequency: this.fingerPrint.estimate_frequency,
        op: this.fingerPrint.op
      }
      getRequest('/refactor/dataRecommendInfo', param).then(function (x) {
        if (!x.data.message) {
          _this.recommendData = x.data.data
          _this.reFunctions = x.data.data.recommend_functions
          _this.recommendIndex = 0
          for (let i = 0; i < _this.reFunctions.length; i++) {
            if (_this.reFunctions[i].common_params && _this.reFunctions[i].common_params.length > 0) {
              _this.reFunctions[i].dropdownKey = _this.reFunctions[i].common_params[0]
            } else {
              _this.reFunctions[i].dropdownKey = ''
            }
            if (_this.dropdownKeyList.length > 0) {
              for (let j = 0; j < _this.dropdownKeyList.length; j++) {
                if (_this.reFunctions[i].title_chinese === _this.dropdownKeyList[j].function && _this.reFunctions[i].common_params.indexOf(_this.dropdownKeyList[j].key) > -1) {
                  _this.reFunctions[i].dropdownKey = _this.dropdownKeyList[j].key
                  break
                }
              }
            }
          }
        }
      })
    }
  },
  watch: {
    expression_id () {
      if (this.expression_id && !this.is_matrix && this.rightBlockType !== 'is_json') {
        this.getFingerPrintbyId()
      } else {
        this.recommendData = {}
      }
    },
    is_matrix () {
    }
  },
  activated () {
  }
}
</script>
<style>
.font_s_14 {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/allPage/recommonOperate.vue